export class Contacto {
    public id_cia: number;
     public codcont: number;
    public nomcont: string;
    public direccion: string;
    public email: string;
    public telefono: string;
    public hobby: string;
    public palabraclave: string;
    public observacion: string;
    public cargo: string;
    public fcreac: string;
    public factua: string;
    public usuari: string;
    public activo: boolean;
    public felicitacion: string;
    public coddeci: number;
    public codpro: number;
    public codtra: number;
    public codrel: number;
    public coddep: string;
    public codprv: string;
    public coddis: string;
}